import { supabase } from '../../integrations/supabase/client';
import type { IClientHierarchyRepository, ClientHierarchy, HierarchyNode } from '../interfaces/IClientHierarchyRepository';

export class SupabaseClientHierarchyRepository implements IClientHierarchyRepository {
  async getHierarchy(rootClientId: string): Promise<HierarchyNode[]> {
    const { data, error } = await (supabase.rpc as any)('get_client_hierarchy', {
      root_client_id: rootClientId,
    });

    if (error) throw error;
    return (data || []) as unknown as HierarchyNode[];
  }

  async createRelationship(data: {
    parent_client_id: string;
    child_client_id: string;
    relationship_type: string;
    inheritance_rules?: any;
    autonomy_level?: string;
  }): Promise<ClientHierarchy> {
    const { data: relationship, error } = await ((supabase as any)
      .from('client_hierarchies')
      .insert(data)
      .select()
      .single());

    if (error) throw error;
    return relationship as unknown as ClientHierarchy;
  }

  async updateRelationship(id: string, updates: Partial<ClientHierarchy>): Promise<ClientHierarchy> {
    const { data, error } = await ((supabase as any)
      .from('client_hierarchies')
      .update(updates)
      .eq('id', id)
      .select()
      .single());

    if (error) throw error;
    return data as unknown as ClientHierarchy;
  }

  async deleteRelationship(id: string): Promise<void> {
    const { error } = await ((supabase as any)
      .from('client_hierarchies')
      .delete()
      .eq('id', id));

    if (error) throw error;
  }

  async getChildren(parentClientId: string): Promise<ClientHierarchy[]> {
    const { data, error } = await ((supabase as any)
      .from('client_hierarchies')
      .select('*')
      .eq('parent_client_id', parentClientId)
      .eq('status', 'active'));

    if (error) throw error;
    return (data || []) as unknown as ClientHierarchy[];
  }

  async getParent(childClientId: string): Promise<ClientHierarchy | null> {
    const { data, error } = await ((supabase as any)
      .from('client_hierarchies')
      .select('*')
      .eq('child_client_id', childClientId)
      .eq('status', 'active')
      .single());

    if (error) return null;
    return data as unknown as ClientHierarchy;
  }
}
